export const PENSION_FUND_LABEL_AR = "برناج التقاعد";
export const PENSION_FUND_LABEL_HE = "קרן פנסיה";